import React from 'react'
import { Instances } from './s'
import Instance from './instance'

const IntegrationInstances = ({ instances = [] }) => (
    <Instances>
        {instances.map(instance => (
            <Instance
                instance={instance}
                key={instance.id} />
        ))}
    </Instances>
)

export default IntegrationInstances